import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "events/";

class EventService {
  getEvents(bookingId, cursorEventId) {
    return axios.post(
      ENDPOINT_URL + "list/" + bookingId,
      { cursorEventId },
      { headers: authHeader() },
    );
  }

  renderEmail(template, lang, context) {
    return axios.post(
      `${API_URL}communications/render-email-event`,
      { template, lang, context },
      { headers: authHeader() },
    );
  }
}

export default new EventService();
